var map = {
	"./again.mp3": 770,
	"./not_standard.mp3": 23,
	"./prepare.mp3": 1251,
	"./stage0.mp3": 1496,
	"./stage0_end.mp3": 1518,
	"./stage1.mp3": 7869,
	"./stage1_end.mp3": 2255,
	"./stage2.mp3": 9866,
	"./stage2_end.mp3": 8752,
	"./stage3.mp3": 3919,
	"./stage3_end.mp3": 5105,
	"./stage4.mp3": 292,
	"./stage4_end.mp3": 9354,
	"./start_test.mp3": 2009
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8641;